module.exports = __webpack_public_path__ + "img/group.6690365a.png";